import { createAxiosKPIs, createAxiosHeadersKPIs } from "./axiosHttpMarconi";
import { franquiciaService } from "./franquicia.service";

export const KPIsService = { get, excel };

function get(filters) {
  const franquicia = franquiciaService.getLocalFranquicia();
  filters.franquicia = franquicia._id;
  const axios = createAxiosKPIs();
  let urlPath = `kpis`;
  const params = new URLSearchParams(filters);

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function excel(filters) {
  const usuario = JSON.parse(localStorage.getItem("user"));
  filters.franquicia =franquiciaService.getLocalFranquicia()._id;
    
  const axios = createAxiosHeadersKPIs();
  let urlPath = `kpis/excel`;
  const params = new URLSearchParams(filters);

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}
